var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',[(this.pagedata)?_c('div',{staticClass:"container"},[_c('h1',{staticClass:"page-title"},[_vm._v(_vm._s(this.pagedata.attributes.title))])]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }